import { takeEvery, put, select, fork } from "redux-saga/effects"
import types from "./actionTypes"
import searchAPI from "../../../api/search"
import { Modal } from "antd"
import moment from "moment"
import { Promise } from "es6-promise"

function* processSearch({ data }) {
  const result = yield searchAPI.searchMember(data)
  yield put({ type: types.SEARCH_USER_COMPLETE, data: result })
}

function* fetchMemberData({ data }) {
  const result = yield searchAPI.getMemberById(data)
  yield put({ type: types.SEARCH_GET_MEMBER_COMPLETE, data: result })
}

function* fetchPointHistory({ data }) {
  const result = yield searchAPI.getMemberPointHistory(data)
  yield put({ type: types.LOAD_HISTORY_COMPLETE, data: result })
}

const delay = (time) => new Promise((resolve) => setTimeout(resolve, time))

function* expireCode(idx, ms) {
  yield delay(ms)
  yield put({ type: types.USE_PRIVILEGE_EXPIRE, idx: idx })
}

function* fetchAvailablePrivilege({ data }) {
  const result = yield searchAPI.getMemberAvailablePrivilege(data)

  let codes = []
  for (const index in result) {
    if (result[index].code) {
      for (const idx in result[index].code) {
        const elem = result[index].code[idx]
        if (elem.expired_at) {
          const expireSecond = moment(elem.expired_at).unix() - moment().unix()
          yield fork(expireCode, elem.id, expireSecond * 1000)
        }

        codes.push({
          pid: result[index].id,
          objId: elem.id,
          code: elem,
        })
      }
    }
  }

  yield put({
    type: types.LOAD_PRIVILEGE_COMPLETE,
    data: {
      privilege: result,
      activeCode: codes,
    },
  })
}

function* processClaimPrivilege({ data }) {
  let useSuccess = []
  let errorMessage = null

  let series = null
  // eslint-disable-next-line
  for (const _ in [...Array(data.amount).keys()]) {
    try {
      const result = yield searchAPI.usePrivilege(
        data.memberId,
        data.id,
        data.params,
        series
      )
      if (result.message && result.message.startsWith("error")) {
        errorMessage = result.message
        break
      } else {
        if (result.expired_at) {
          const expireSecond =
            moment(result.expired_at).unix() - moment().unix()
          yield fork(expireCode, result.id, expireSecond * 1000)
        }

        if (!series) {
          series = result.code
        }

        useSuccess.push({
          pid: data.id,
          objId: result.id,
          code: result,
        })
      }
    } catch (e) {
      break
    }
  }

  if (useSuccess.length === 0) {
    Modal.error({
      title: "ไม่สามารถใช้สิทธิพิเศษได้",
      content: errorMessage,
    })
    yield put({ type: types.USE_PRIVILEGE_ERROR, data: data.id })
  } else if (useSuccess.length < data.amount) {
    Modal.error({
      title: "ไม่สามารถใช้สิทธิพิเศษได้ครบทุกสิทธิ์",
      content: `สามารถใช้สิทธิพิเศษได้ ${useSuccess.length} สิทธิ์`,
    })
  }

  yield put({
    type: types.USE_PRIVILEGE_COMPLETE,
    data: useSuccess,
  })
  yield fetchMemberData({ data: data.memberId })
}

function* processConfirmCodeUse({ data }) {
  try {
    yield searchAPI.confirmMultipleUseCode(
      data.memberId,
      data.pid,
      data.code.map((item) => item.objId),
      data.password
    )
    yield put({
      type: types.CONFIRM_PRIVILEGE_USE_COMPLETE,
      data: data.pid,
    })
  } catch (e) {
    let message = "เนื่องจากการเชื่อมต่อ หรือ ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง"

    if (e.response.data.message === "invalid_password") {
      message = "รหัสผ่านไม่ถูกต้อง"
    } else if (e.response.data.message === "invalid_code") {
      message = "ไม่พบโด้ดที่ต้องการยืนยัน"
    }

    Modal.error({
      title: "การดำเนินการล้มเหลว",
      content: message,
    })

    yield put({ type: types.CONFIRM_PRIVILEGE_USE_FAIL, data: data.pid })
  }
}

function* processActivateCard({ data }) {
  try {
    const callback = data.cb

    yield searchAPI.activateCard(data.memberId, {
      card_id: data.cardId,
      secret: data.secret,
    })

    yield fetchMemberData({ data: data.memberId })
    const state = yield select()
    if (state.search.keyword) {
      yield put({ type: types.SEARCH_USER, data: state.search.keyword })
    }
    yield put({ type: types.ACTIVATE_CARD_COMPLETE })

    // Hide Modal
    callback()

    yield put({ type: types.LOAD_PRIVILEGE, data: data.memberId, silent: true })
  } catch (e) {
    let message = "เนื่องจากการเชื่อมต่อ หรือ ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง"

    if (e.response.data.message === "invalid_code") {
      message = "รหัสยืนยันไม่ถูกต้อง"
    } else if (e.response.data.message === "already_use") {
      message = "บัตรสมาชิกถูกใช้ไปแล้ว"
    } else if (e.response.data.message === "member_not_found") {
      message = "ไม่พบข้อมูลบัตรสมาชิก"
    } else if (e.response.data.message === "card_exists") {
      message = "สมาชิกมีบัตรอยู่แล้ว"
    }

    Modal.error({
      title: "ไม่สามารถเปิดใช้งานบัตรสมาชิกได้",
      content: message,
    })
    yield put({ type: types.ACTIVATE_FAIL })
  }
}

function* searchSaga() {
  yield takeEvery(types.SEARCH_USER, processSearch)
  yield takeEvery(types.SEARCH_GET_MEMBER, fetchMemberData)
  yield takeEvery(types.LOAD_HISTORY, fetchPointHistory)
  yield takeEvery(types.LOAD_PRIVILEGE, fetchAvailablePrivilege)
  yield takeEvery(types.USE_PRIVILEGE, processClaimPrivilege)
  yield takeEvery(types.CONFIRM_PRIVILEGE_USE, processConfirmCodeUse)
  yield takeEvery(types.ACTIVATE_CARD, processActivateCard)
}

export default searchSaga



// WEBPACK FOOTER //
// ./src/containers/Search/store/sagas.js